<template>
	<dl class="couple">
		<dt v-if="title" ref="title" :class="{'auto-width': autoWidth }"><span>{{title}}<i v-if="required" class="required"></i></span></dt>
		<dd :class="classes" ref="content"><slot></slot></dd>
	</dl>
</template>
<script>
	export default {
		name: 'couple',
		props: {
			title: {
				type: String,
				default: ''
			},
			wrap: {
				type: String,
				default: '',
			},
			autoWidth: {
				type: Boolean,
			},
			ellipsis: {
				type: Boolean,
				default: true
			},
			required:{
				type: Boolean,
				default: false
			}
		},
		computed: {
			classes() {
				return [`${this.wrap}`]
			}
		},
		mounted() {
			if (this.$refs.title) {
				var w = this.$el.clientWidth-this.$refs.title.clientWidth-32;
				this.$refs.content.style.width = `${w}px`
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/couple/couple.vue